import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { api } from '../lib/api';

// Email+password sign-in via Better Auth's canonical endpoint. We don't wire
// up the @better-auth/client package — it's a single form and a single
// endpoint, and avoiding the client dep keeps the SPA bundle tiny.
export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const qc = useQueryClient();

  const signIn = useMutation({
    mutationFn: async () => api.post('/api/auth/sign-in/email', { email, password }),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ['me'] });
      navigate('/');
    },
    onError: (err: Error) => setError(err.message),
  });

  return (
    <div className="mx-auto max-w-sm p-8">
      <h1 className="text-xl font-semibold">Aiport</h1>
      <p className="mt-2 text-sm text-neutral-500">
        Plaine's stand-in third-party owner. Only the configured founder email can sign in.
      </p>
      <form
        className="mt-6 space-y-3"
        onSubmit={(e) => {
          e.preventDefault();
          setError(null);
          signIn.mutate();
        }}
      >
        <input
          type="email"
          autoComplete="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="email"
          className="w-full rounded border border-neutral-300 px-3 py-2 text-sm"
        />
        <input
          type="password"
          autoComplete="current-password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="password"
          className="w-full rounded border border-neutral-300 px-3 py-2 text-sm"
        />
        <button
          type="submit"
          disabled={signIn.isPending}
          className="w-full rounded bg-neutral-900 px-3 py-2 text-sm font-medium text-white disabled:opacity-50"
        >
          {signIn.isPending ? 'Signing in…' : 'Sign in'}
        </button>
        {error && <p className="text-sm text-red-600">{error}</p>}
      </form>
    </div>
  );
}
